import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../api/authentication.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.css']
})
export class MenuBarComponent implements OnInit {

  constructor(private authService: AuthenticationService,
    private navigator: NavigationService) { }

  ngOnInit() {
  }

  logout() {
    this.authService.logout(false);
  }
}
